import React, { createContext, useContext, useMemo } from 'react'
import { useGetMySettingsQuery } from '../api/v2/settings'
import { useGetEventUserQuery } from '../api/eventUser.api'
import { useMyContext } from '../context/context'
import MyLoading from '../components/MyLoading'
import { useLanguage } from './useLanguages'

const SettingsContext = createContext(null)

export function useSettingsV3() {
  const ctx = useContext(SettingsContext)
  if (!ctx) throw new Error('useSettings must be used within <SettingsProvider>')
  return ctx
}

export function SettingsProvider({ children }) {
  const { myContext } = useMyContext()
  const { languageId } = useLanguage()

  // On lit le typoId depuis la QUERY (cache RTK) et non depuis `user` du contexte, qui est un
  // état local rafraîchi par effet : sinon la clé de la requête settings a un render de retard,
  // ce qui rouvre la fenêtre de course que `settling` cherche justement à fermer.
  const { data: userEvent } = useGetEventUserQuery(myContext, {
    skip: !myContext?.eventId || !myContext?.domainId || !myContext?.userId,
  })

  const { data: settings, isLoading, isFetching } = useGetMySettingsQuery({
    ...myContext,
    userId: undefined,
    languageId,
    typoId: userEvent?.UserEvent?.typoId,
  })

  // `isFetching` (et non `isLoading`) : vrai aussi lors des RE-fetch, notamment quand le typoId
  // change et que la cascade de settings scopée par typo se recharge -> gèle les auto-sauts.
  const value = useMemo(() => ({ settings, isFetching }), [settings, isFetching])

  return (
    <MyLoading loading={isLoading}>
      {isLoading ? <div /> : <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>}
    </MyLoading>
  )
}
